var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import defaultRenderer from "./RowRenderers";
import { RadioInput, RadioOptionLabel } from "./styled";
var RadioOption = /** @class */ (function (_super) {
    __extends(RadioOption, _super);
    function RadioOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            _this.props.onChange(parseInt(e.currentTarget.value, 10));
        };
        return _this;
    }
    RadioOption.prototype.render = function () {
        var _a = this.props, option = _a.option, value = _a.value, disabled = _a.disabled, checked = _a.checked, className = _a.className, inline = _a.inline, rowRenderer = _a.rowRenderer, name = _a.name;
        var idNamespace = id("Radio", this.props);
        return (React.createElement(RadioOptionLabel, { id: id("Label", idNamespace), htmlFor: idNamespace, className: className, inline: inline },
            React.createElement(RadioInput, { id: idNamespace, name: name, checked: checked, value: value, disabled: disabled, type: "radio", onChange: this.handleChange }),
            rowRenderer && rowRenderer({ option: option, disabled: disabled, checked: checked }),
            !rowRenderer && defaultRenderer({ option: option, disabled: disabled, checked: checked })));
    };
    return RadioOption;
}(Component));
export default RadioOption;
